import React from 'react';
import { Stack, Typography } from '@mui/material';
import ChannelStatistics from '../../../../components/channel/[channelId]/video/dashboard/channel/ChannelStatistics';
import { useAuth } from 'react-oidc-context';
import { useUserContext } from 'hooks';

const Dashboard: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const { channel } = useUserContext();
    if (!isAuthenticated) {
        return <div>User not logged in</div>;
    }
    return (
        <Stack sx={{ paddingTop: '40px' }}>
            <Typography variant="h5" gutterBottom component="div">
                Channel Dashboard
            </Typography>
            <ChannelStatistics channelId={channel?.id ?? ''} />
        </Stack>
    );
};

export default Dashboard;
